import React, { Component } from 'react';
import HiringDetail from '../../Common/HiringDetail/HiringDetail'
import HeaderWhite from "../../Common/HeaderWhite/HeaderWhite";
import FooterMainWhite from "../../Common/FooterMainWhite/FooterMainWhite";

class RouterHiringDetail extends Component {
    render() {
        return (
            <div>
                <HeaderWhite />
                <HiringDetail />
                <FooterMainWhite />
            </div>
        );
    }
}

export default RouterHiringDetail;